import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { getConsultorResponse } from '../../../../../lib/api';
import CenteredCircularProgress from '../../../../../lib/designSystem/CircularProgress';
import HeaderWithActions from '../../../../../lib/designSystem/HeaderWithActions';
import EnhancedTable from '../../../../../lib/designSystem/Table';

interface BankruptcyPost {
  Rol: string;
  'Procedimiento Concursal': string;
  Deudor: string;
  'Veedor Liquidador Titular': string;
}
const bankruptcyHeaders = [
  { key: 'Rol', label: 'Rol' },
  { key: 'Procedimiento Concursal', label: 'Procedimiento ' },
  { key: 'Deudor', label: 'Deudor' },
  { key: 'Veedor Liquidador Titular', label: 'Veedor Liquidador Titular' },
  { key: 'Nombre Publicación', label: 'Publicación' },
  { key: 'Tribunal', label: 'Tribunal' },
  { key: 'Fecha Publicación', label: 'Publicación' },
];

const BaknrruptcyPosts = (props: { businessIdentifier?: string }) => {
  const { businessIdentifier } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<BankruptcyPost[]>([]);
  const { id } = useParams<{
    id: string;
    businessId: string;
    page: string;
  }>();
  const businessId = id || businessIdentifier;

  const fetchRelations = async () => {
    if (!businessId) {
      alert('No se ha encontrado el id de la empresa');
      return;
    }
    setLoading(true);
    try {
      const responseConsult = await getConsultorResponse(dispatch, {
        payload: {
          identifier: businessId.toUpperCase(),
        },
        consult: 'bankruptcy',
        type: 'rut',
      });
      setResponse(responseConsult.data[businessId.toLocaleLowerCase()] || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void fetchRelations();
  }, []);

  if (loading) return <CenteredCircularProgress relative />;

  return (
    <div>
      <HeaderWithActions variant="h6" subHeader buttons={[]} title="" />
      <EnhancedTable
        dataHeaders={bankruptcyHeaders}
        data={response}
        rowsPerPageDefault={100}
      />
      {loading && <CenteredCircularProgress relative />}
    </div>
  );
};

export default BaknrruptcyPosts;
